import React, { Suspense, lazy } from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SECTION_PATHS } from '@wix/da-url';
import withFeatureFlags, {
  WithFeatureFlagsProps,
} from '@wix/da-react-context/pkg/flags/withFeatureFlags';
import AboutMe, { Props as WidgetProps } from './AboutMe';
import reduxConnectContainer from './AboutMe.container';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import ChunkLoadingPopover from '../_partials/ChunkLoadingPopover';
import { AboutMeMode } from './types';

const AboutMeEditPopup = lazy(
  () => import(/* webpackChunkName: "owner" */ './AboutMeEditPopup')
);

export interface Props {
  isMobile: boolean;
}

class AboutMeBox extends React.Component<
  Props & WidgetProps & WidgetBoxProps & WithTranslation & WithFeatureFlagsProps
> {
  render() {
    const {
      t,
      isMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      hasJoinedWithEclipse,
      section,
      zone,
      flags,
      ...props
    } = this.props;

    const profile_mobile_heading = flags.includes('profile_mobile_heading');

    const tooltipTitle = hasJoinedWithEclipse
      ? t('widgets.aboutMe.edit.tooltip.newuser.title')
      : t('widgets.aboutMe.edit.tooltip.existinguser.title');
    const tooltipContent = hasJoinedWithEclipse
      ? t('widgets.aboutMe.edit.tooltip.newuser.message')
      : t('widgets.aboutMe.edit.tooltip.existinguser.message');

    return (
      <WidgetBox
        section={section}
        zone={zone}
        header={t!('widgets.aboutMe.headerWithUsername', {
          username: props.user.username,
        })}
        isEmpty={isMobile && props.isEmpty}
        seeAllUrl={Url.userLink(
          props.user.username,
          `${USER_PROFILE_SECTION_PATHS.ABOUT}`
        )}
        seeAllText={profile_mobile_heading ? undefined : t!('common.more')}
        moduleId={props.moduleId}
        allowEditOnMobile={false}
        widgetMenuRenderer={this.renderEditModal}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        editControlsTooltipTitle={tooltipTitle}
        editControlsTooltipContent={tooltipContent}
      >
        <AboutMe mode={AboutMeMode.CARD} {...props} />
      </WidgetBox>
    );
  }

  renderEditModal = closeModal => {
    return (
      <Suspense fallback={<ChunkLoadingPopover />}>
        <AboutMeEditPopup
          username={this.props.user.username}
          moduleId={this.props.moduleId}
          onClose={closeModal}
        />
      </Suspense>
    );
  };
}

const enhance = compose(
  reduxConnectContainer,
  withFeatureFlags,
  withTranslation()
);

export default enhance(AboutMeBox) as React.ComponentType<{}>;
